import { Star } from "lucide-react";
import gemeosLogo from "@/assets/logos/gemeos-refrigeracao.png";
import patasPelosLogo from "@/assets/logos/patas-e-pelos.png";
import reiDasPortasLogo from "@/assets/logos/rei-das-portas.png";
import oticaOficinaLogo from "@/assets/logos/otica-oficina-dos-oculos.png";
import tudoPatuLogo from "@/assets/logos/tudo-patu.png";
import mrChipLogo from "@/assets/logos/mr-chip.png";
import jaRefrigeracaoLogo from "@/assets/logos/ja-refrigeracao.png";
import apacLogo from "@/assets/logos/apac.png";
import destaPodcastLogo from "@/assets/logos/desta-podcast.png";
import fzProducoesLogo from "@/assets/logos/fz-producoes.png";
import gilEletricaLogo from "@/assets/logos/gil-eletrica.png";
import lopesImobiliariaLogo from "@/assets/logos/lopes-imobiliaria.png";
import pereiraConstrucaoLogo from "@/assets/logos/pereira-construcao.png";
import torresMelloLogo from "@/assets/logos/torres-e-mello.png";
import unahAvioesLogo from "@/assets/logos/unah-avioes.png";

const clients = [
  { name: "Gêmeos Refrigeração", logo: gemeosLogo },
  { name: "Patas & Pelos", logo: patasPelosLogo },
  { name: "Rei das Portas", logo: reiDasPortasLogo },
  { name: "Ótica Oficina dos Óculos", logo: oticaOficinaLogo },
  { name: "Tudo Patu", logo: tudoPatuLogo },
  { name: "Mr. Chip", logo: mrChipLogo },
  { name: "JA Refrigeração", logo: jaRefrigeracaoLogo },
  { name: "APAC", logo: apacLogo },
  { name: "Desta Podcast", logo: destaPodcastLogo },
  { name: "FZ Produções", logo: fzProducoesLogo },
  { name: "Gil Elétrica", logo: gilEletricaLogo },
  { name: "Lopes Imobiliária", logo: lopesImobiliariaLogo },
  { name: "Pereira Construção", logo: pereiraConstrucaoLogo },
  { name: "Torres & Mello", logo: torresMelloLogo },
  { name: "UNAH Aviões", logo: unahAvioesLogo },
];

const testimonials = [
  {
    name: "Durval Jr",
    company: "Bepop Music",
    avatar: "CS",
    rating: 5,
    text: "Sou realmente grato e muito fã do seu trabalho e sua pessoa. A equipe é extremamente competente. E você passa sempre aquela convicção de tudo que lhe compete foi executado perfeito.",
  },
  {
    name: "Ana Dias",
    company: "J & A Refrigeração",
    avatar: "AB",
    rating: 5,
    text: "Depois que contratei o escritório, parei de ter dor de cabeça com imposto. Eles resolvem tudo pra mim.",
  },
  {
    name: "Thiago Santos",
    company: "TS Arquitetura",
    avatar: "RM",
    rating: 5,
    text: "Meu faturamento aumentou e eu não sabia a hora certa de mudar. Procurei Daiane por indicação e ela me orientou na hora certa pra mudar de categoria. Muito parceiros!",
  },
];

const TestimonialsSection = () => {
  return (
    <section className="min-h-screen flex flex-col justify-center py-24 bg-white overflow-hidden">
      <div className="container mx-auto px-4">
        {/* Clients Carousel */}
        <div className="mb-20">
          <p className="text-center text-muted-foreground mb-8 text-sm uppercase tracking-wider">
            <strong>Empresas que confiam em nosso trabalho</strong>
          </p>
          <div className="relative">
            <div className="flex gap-16 infinite-scroll">
              {[...clients, ...clients].map((client, index) => (
                <div
                  key={`${client.name}-${index}`}
                  className="flex-shrink-0 w-56 h-32 flex items-center justify-center"
                >
                  <img src={client.logo} alt={client.name} className="max-h-full max-w-full object-contain" />
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Testimonials */}
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-12">
            <span className="inline-block bg-emerald-green/10 text-emerald-green px-4 py-2 rounded-full text-sm font-medium mb-4">
              Depoimentos
            </span>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-petrol-blue">
              O que dizem nossos parceiros
            </h2>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {testimonials.map((testimonial) => (
              <div
                key={testimonial.name}
                className="bg-ice-gray rounded-2xl p-6 hover:shadow-[var(--shadow-card)] transition-shadow duration-300"
              >
                {/* Stars */}
                <div className="flex gap-1 mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="h-5 w-5 fill-yellow-400 text-yellow-400" />
                  ))}
                </div>

                {/* Text */}
                <p className="text-muted-foreground mb-6 leading-relaxed">
                  "{testimonial.text}"
                </p>

                {/* Author */}
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 rounded-full bg-petrol-blue flex items-center justify-center">
                    <span className="text-white font-semibold">
                      {testimonial.avatar}
                    </span>
                  </div>
                  <div>
                    <p className="font-semibold text-graphite">{testimonial.name}</p>
                    <p className="text-sm text-muted-foreground">{testimonial.company}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Google Reviews Badge */}
          <div className="mt-12 flex justify-center">
            <div className="flex items-center gap-3 bg-ice-gray rounded-full px-6 py-3">
              <img
                src="https://www.google.com/images/branding/googlelogo/2x/googlelogo_color_92x30dp.png"
                alt="Google"
                className="h-5 object-contain"
              />
              <div className="flex gap-1">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="h-4 w-4 fill-yellow-400 text-yellow-400" />
                ))}
              </div>
              <span className="text-sm font-medium text-graphite">4.9 no Google</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
